import { Text } from "@dropbox/dig-components/typography";
import { ToolCallStatusIndicator } from "@mirage/mosaics/Chat/components/chat/ConversationMessages/ToolCalls/ToolCallStatusIndicator";
import type { ToolCallProgressStatus } from "@mirage/mosaics/Chat/components/chat/ConversationMessages/ToolCalls/types";
import { memo } from "react";
import styles from "./ToolCallRowLayout.module.css";

export interface ToolCallRowLayoutProps {
  actionLabel: string;
  fields: Array<{
    label: React.ReactNode;
    value: React.ReactNode;
  }>;
  status: ToolCallProgressStatus | undefined;
}
export const ToolCallRowLayout = memo(
  ({ actionLabel, fields, status }: ToolCallRowLayoutProps) => {
    return (
      <div className={styles.ToolCallRowLayout}>
        <Text tagName="div" isBold>
          {actionLabel}
        </Text>
        {fields.map((field, index) => (
          <div key={index} className={styles.ToolCallRowLayoutField}>
            <Text
              tagName="div"
              color="subtle"
              className={styles.ToolCallRowLayoutFieldLabel}
            >
              {field.label}
            </Text>
            <Text tagName="div">{field.value}</Text>
          </div>
        ))}
        <div className={styles.ToolCallRowLayoutStatus}>
          <ToolCallStatusIndicator status={status} />
        </div>
      </div>
    );
  },
);
ToolCallRowLayout.displayName = "ToolCallRowLayout";
